import type { H3CustomOption } from "@/components/spatialAnalysis/spatialOutputAnalysis/data";
import type { IOptionItem } from "@/components/ui/dropdown/types";
import {
  GEOHASH_AREA_SIZE,
  GEOHASH_RESOLUTION_LABEL,
  H3_AREA_SIZE,
  H3_RESOLUTION_META,
  MAX_GRID_CELL_COUNT
} from "@/constants/spatialResolution";
import { GeohashResolution, H3Resolution } from "@/types/analysisHistory";

// ------------------ GEOHASH RESOLUTIONS LEVEL ---------------------//
const GEOHASH_RESOLUTIONS = Object.values(GeohashResolution).filter(
  Number.isInteger
) as GeohashResolution[];

// ------------------ H3 RESOLUTIONS LEVEL ---------------------//
const H3_RESOLUTIONS = Object.values(H3Resolution).filter(
  Number.isInteger
) as H3Resolution[];

//------------------ GEOHASH SELECT OPTIONS ---------------------//
export const buildGeohashOptions = (areaSize: number): IOptionItem[] =>
  GEOHASH_RESOLUTIONS.map((resolution) => ({
    value: String(resolution),
    label: `${resolution} ${GEOHASH_RESOLUTION_LABEL[resolution]}`,
    disabled: areaSize / GEOHASH_AREA_SIZE[resolution] >= MAX_GRID_CELL_COUNT
  }));

//------------------ H3 SELECT OPTIONS ---------------------//
export const buildH3Options = (areaSize: number): H3CustomOption[] =>
  H3_RESOLUTIONS.map((resolution) => ({
    value: String(resolution),
    label: `${H3_RESOLUTION_META[resolution].areaKm2} Km2`,
    radius: `${H3_RESOLUTION_META[resolution].radiusKm} Km`,
    disabled: areaSize / H3_AREA_SIZE[resolution] >= MAX_GRID_CELL_COUNT
  }));
